import { filterDuplicateData } from 'redux/modules/sections';
export const MERGE_IN_SETTINGS = 'MERGE_IN_SETTINGS';
export const ADD_SECTION_SETTING = 'ADD_SECTION_SETTING';
export const ADD_CRM_SECTION_SETTING = 'ADD_CRM_SECTION_SETTING';
const UPDATE_TEMPID_SETTING = 'UPDATE_TEMPID_SETTING';
const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const ADD_GlobalSection_SECTION_SETTING = 'ADD_GlobalSection_SECTION_SETTING';
const ADD_OPTIONS_SETTINGS = 'ADD_OPTIONS_SETTINGS';
const BATCH_UPDATE_OPTIONS_SETTINGS = 'BATCH_UPDATE_OPTIONS_SETTINGS';
const UPDATE_FORM_SETTINGS = 'UPDATE_FORM_SETTINGS';
const UPDATE_FORM_FORM_BG_SETTINGS = 'UPDATE_FORM_FORM_BG_SETTINGS';
const UPDATE_FORM_SECTION_BG_SETTINGS = 'UPDATE_FORM_SECTION_BG_SETTINGS';

export default function settings(state = {}, action) {
    switch (action.type) {
        case MERGE_IN_SETTINGS:
            return { ...state, ...action.payload };
        case ADD_SECTION_SETTING: {
            const { sectionId, fieldId, settings } = action.payload;
            const newSectionSetting = state.sections
                ? [...state.sections, { id: sectionId, ...settings.sections }]
                : [...(state.sections = []), { id: sectionId, ...settings.sections }];

            const newFieldSetting = settings.fields
                ? state.fields
                    ? [...state.fields, { id: fieldId, ...settings.fields }]
                    : [...(state.fields = []), { id: fieldId, ...settings.fields }]
                : [...state.fields];

            // const newOptionSetting =
            //     state.options && settings.options
            //         ? [...state.options, settings.options]
            //         : [...(state.options = []), settings.options];

            return {
                ...state,
                sections: [...newSectionSetting],
                fields: [...newFieldSetting]
            };
        }
        case ADD_GlobalSection_SECTION_SETTING: {
            const { sections, fields, options } = action.payload;
            const clearSections = filterDuplicateData(state.sections, sections);
            const clearFields = filterDuplicateData(state.fields, fields);
            const clearOptions = filterDuplicateData(state.options, options);
            return {
                ...state,
                sections: [...clearSections, ...sections],
                fields: [...clearFields, ...fields],
                options: [...clearOptions, ...options]
            };
        }
        case UPDATE_TEMPID_SETTING: {
            const { mapSections, mapFields, mapOptions } = action.payload;
            const sectionsReplaceTemp = Object.keys(mapSections).length
                ? { sections: updateId('id', state.sections, mapSections) }
                : undefined;
            const fieldsReplaceTemp = Object.keys(mapFields).length
                ? { fields: updateId('id', state.fields, mapFields) }
                : undefined;
            const optionsReplaceTemp = Object.keys(mapOptions).length
                ? { options: updateId('id', state.options, mapOptions) }
                : undefined;

            const settings = {
                ...sectionsReplaceTemp,
                ...fieldsReplaceTemp,
                ...optionsReplaceTemp
            };
            return {
                ...state,
                ...settings
            };
        }
        case UPDATE_SETTINGS: {
            const { level, id, setting: newSetting } = action.payload;
            const updateItem = state[level].find(setting => setting.id === id);
            if (updateItem) {
                const updateSetting = state[level].map(setting => {
                    if (setting.id === id) {
                        return { ...setting, ...newSetting };
                    }

                    return setting;
                });
                return { ...state, [level]: updateSetting };
            } else {
                return {
                    ...state,
                    [level]: [].concat(state[level], { id: id, ...newSetting })
                };
            }
        }
        case UPDATE_FORM_SETTINGS: {
            const { settings } = action.payload;
            return {
                ...state,
                form: { ...state.form, ...settings }
            };
        }
        case UPDATE_FORM_FORM_BG_SETTINGS: {
            const { settings } = action.payload;
            return {
                ...state,
                form: {
                    ...state.form,
                    formBg: { ...state.form.formBg, ...settings }
                }
            };
        }
        case UPDATE_FORM_SECTION_BG_SETTINGS: {
            const { settings } = action.payload;
            return {
                ...state,
                form: {
                    ...state.form,
                    formContentBg: { ...state.form.formContentBg, ...settings }
                }
            };
        }
        case ADD_OPTIONS_SETTINGS: {
            const { optionId, settings } = action.payload;
            return {
                ...state,
                options: [...state.options, { id: optionId, ...settings }]
            };
        }
        case BATCH_UPDATE_OPTIONS_SETTINGS: {
            /**
             * 批量更新選項設定
             * 用於一次性更新多個選項的設定，避免多次 dispatch 造成的效能問題
             *
             * 處理邏輯：
             * 1. 遍歷所有要更新的選項
             * 2. 如果選項已存在，則更新其設定
             * 3. 如果選項不存在，則新增該選項
             * 4. 返回更新後的 state
             */
            const { optionsUpdates } = action.payload;
            const existingOptions = state.options || [];

            // 處理所有更新
            const updatedOptions = [...existingOptions];
            const newOptions = [];

            Object.entries(optionsUpdates).forEach(([optionId, settings]) => {
                const numericOptionId = Number(optionId);
                const existingIndex = updatedOptions.findIndex(
                    option => option.id === numericOptionId
                );

                if (existingIndex !== -1) {
                    // 更新現有的 option
                    updatedOptions[existingIndex] = {
                        ...updatedOptions[existingIndex],
                        ...settings
                    };
                } else {
                    // 添加新的 option
                    newOptions.push({
                        id: numericOptionId,
                        ...settings
                    });
                }
            });

            return {
                ...state,
                options: [...updatedOptions, ...newOptions]
            };
        }
        default:
            return state;
    }
}

export function updateSettings(level, id, setting) {
    return {
        type: UPDATE_SETTINGS,
        payload: {
            level,
            id,
            setting
        }
    };
}

export function addSectionSetting(settings) {
    return {
        type: ADD_SECTION_SETTING,
        payload: settings
    };
}

export function addGlobalSectionSectionSetting({ sections = [], fields = [], options = [] }) {
    return {
        type: ADD_GlobalSection_SECTION_SETTING,
        payload: { sections, fields, options }
    };
}

export function updateTempIdSetting(sections = {}, fields = {}, options = {}) {
    return {
        type: 'UPDATE_TEMPID_SETTING',
        payload: {
            mapSections: sections,
            mapFields: fields,
            mapOptions: options
        }
    };
}

export function updateId(key, datas, mappingData) {
    const updateData = datas.reduce((arr, data) => {
        const idValue = data[key];
        if (mappingData[idValue]) {
            arr.push({ ...data, [key]: mappingData[idValue] });
        } else {
            arr.push(data);
        }
        return arr;
    }, []);
    return updateData;
}

export function updateFormSetting(settings) {
    return {
        type: UPDATE_FORM_SETTINGS,
        payload: { settings }
    };
}

export function updateFormBgSetting(settings) {
    return {
        type: UPDATE_FORM_FORM_BG_SETTINGS,
        payload: { settings }
    };
}

export function updateFormSectionBgSetting(settings) {
    return {
        type: UPDATE_FORM_SECTION_BG_SETTINGS,
        payload: { settings }
    };
}

export function addOptionsSetting(optionId, settings) {
    return {
        type: ADD_OPTIONS_SETTINGS,
        payload: {
            optionId,
            settings
        }
    };
}

/**
 * 批量更新選項設定
 * 用於一次性更新多個選項的設定，提升效能並減少組件重新渲染次數
 *
 * @param {Object} optionsUpdates - 選項更新資料物件
 * @param {string|number} optionsUpdates.optionId - 選項 ID (key)
 * @param {Object} optionsUpdates.settings - 選項設定物件 (value)
 *
 * @example
 * 基本使用方式
 * dispatch(batchUpdateOptionsSettings({
 *     "123": { submissionLimit: 5 },
 *     "456": { submissionLimit: 10, showRest: true },
 *     "789": { submissionLimit: 0 }
 * }));
 *
 * @example
 * 從 Map 轉換後使用
 * const optionUpdatesMap = new Map([
 *     [123, { submissionLimit: 5 }],
 *     [456, { submissionLimit: 10 }]
 * ]);
 * const optionsUpdates = Object.fromEntries(optionUpdatesMap);
 * dispatch(batchUpdateOptionsSettings(optionsUpdates));
 *
 * @example
 * 結合其他設定屬性
 * dispatch(batchUpdateOptionsSettings({
 *     "100": {
 *         submissionLimit: 3,
 *         enableNotification: true,
 *         customMessage: "已達上限"
 *     }
 * }));
 *
 * @returns {Object} Redux action 物件
 */
export function batchUpdateOptionsSettings(optionsUpdates) {
    return {
        type: BATCH_UPDATE_OPTIONS_SETTINGS,
        payload: {
            optionsUpdates
        }
    };
}
